import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TabIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageHint } from '@components/common/PageHint.tsx';
import { FinanceLegacyOptions } from '@services/finance-legacy.service.ts';

// Довідник напрямків бізнесу (entry_projects) - простий перелік, дані вже
// завантажені на рівні сторінки разом з рештою options, тут не дублюємо запит.
export const FinanceLegacyProjectsTab: React.FC<{ options: FinanceLegacyOptions }> = ({ options }) => (
  <Box data-i-doc={TabIndices.DEV_FINANCE_LEGACY_PROJECTS}>
    <PageHint iDoc={TabIndices.DEV_FINANCE_LEGACY_PROJECTS} />

    {options.projects.length === 0 ? (
      <Typography sx={{ mt: 4, textAlign: 'center' }}>Проєктів не знайдено.</Typography>
    ) : (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Назва</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {options.projects.map((project) => (
              <TableRow key={project.value}>
                <TableCell>{project.value}</TableCell>
                <TableCell>{project.label}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);
